// ===== Base constants  =====
export const BasicStates = {
  IDLE: 'idle',
  PLAYING: 'playing',
  WAITING_TIMEOUT: 'waiting_timeout',
};

export const BasicEvents = {
  START: 'start',
  STOP: 'stop',
  PLAY_END: 'play_end',
  TIMEOUT_END: 'timeout_end',
};

// Example base transitions (can be swapped per mode)
export const basicTransitions = {
  [BasicStates.IDLE]: {
    [BasicEvents.START]: BasicStates.PLAYING,
  },
  [BasicStates.PLAYING]: {
    [BasicEvents.STOP]: BasicStates.IDLE,
    [BasicEvents.PLAY_END]: BasicStates.WAITING_TIMEOUT,
  },
  [BasicStates.WAITING_TIMEOUT]: {
    [BasicEvents.STOP]: BasicStates.IDLE,
    [BasicEvents.TIMEOUT_END]: BasicStates.PLAYING,
  },
};

export const basicHooks = {
  onEnter: {
    [BasicStates.WAITING_TIMEOUT]: (ctx, event) => {
      ctx.startTimer1(() => ctx.dispatch({ type: BasicEvents.TIMEOUT_END, timestamp: Date.now() }));
    },
    [BasicStates.PLAYING]: (ctx, event) => {
      ctx.setUi((prev) => ({
        ...prev,
  // Bump using the latest UI snapshot (prev), not ctx.ui, to avoid races
  contentPlayRowToken: (prev.contentPlayRowToken ?? 0) + 1,
        voiceRecordingDisabled: true,
        contentTableDisabled: true,
      }));
    },
    [BasicStates.IDLE]: (ctx, event) => {
      ctx.setUi((prev) => ({
        ...prev,
        stopplay: 0,
        voiceRecordingDisabled: false,
        contentTableDisabled: false,
      }));
    },
  },
  onExit: {
    [BasicStates.WAITING_TIMEOUT]: (ctx, event) => {
      if (event.type === BasicEvents.STOP) {
        // Only clear timer, do not increment token
        ctx.clearTimer();
      } else {
        // For other events, increment token and clear timer
        ctx.setUi((prev) => ({
          ...prev,
          // Bump using the latest UI snapshot (prev), not ctx.ui, to avoid races
          contentAdvanceRowToken: (prev.contentAdvanceRowToken ?? 0) + 1,
        }));
        ctx.clearTimer();
      }
    },
  },
};
